<div class="polymer-presence-disclosure-container">
    <div class="polymer-presence-disclosure-item-container">
        <div class="polymer-presence-disclosure-item-input-container">
            <mat-form-field appearance="outline" class="polymer-presence-disclosure-form-field">
                <mat-label>Please disclose if there is a polymer present</mat-label>
                <input matInput #polymerPresenceDisclosureInput [(ngModel)]="polymerPresenceDisclosure"
                    class="polymer-presence-disclosure polymer-presence-disclosure-item-input"
                    (keyup.enter)="updatePolymerPresenceDisclosure($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updatePolymerPresenceDisclosure($event)" />
                <mat-icon matSuffix (mousedown)="clearPolymerPresenceDisclosureInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
</div>